// start:ng42.barrel
export * from './policies.component';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/policies/index.ts